import { Stack } from 'expo-router';
import { Platform, View } from 'react-native';
import {
  createStyleSheet,
  UnistylesRuntime,
  useStyles,
} from 'react-native-unistyles';

import Checkout from '@/components/checkout';

export default function CheckoutScreen() {
  const { styles } = useStyles(stylesheet);

  return (
    <View style={styles.container}>
      {Platform.OS === 'web' &&
        ['md', 'lg'].includes(UnistylesRuntime.breakpoint) && (
          <Stack.Screen
            options={{
              headerShown: false,
            }}
          />
        )}

      <Checkout />
    </View>
  );
}

const stylesheet = createStyleSheet((theme) => ({
  container: {
    flex: 1,
    backgroundColor: theme.colors.background_1,
  },
}));
